<template>
  <div>
    <group-card title="ADP Breakdown" icon="bubble_chart" padded>
      <md-dialog-content>
        <div class="md-layout input-layout">
          <div class="md-layout-item input-layout md-small-size-25 md-size-25">
            <validated-number-input
              class="md-layout-item md-small-size-100 md-size-100"
              label="Application ID"
              v-model="application_id"
              errormsg="Application ID must be numbers."
            >
            </validated-number-input>
          </div>
          <md-dialog-actions class="show-list-button">
            <loading-icon-text-button
              @click="getMlAssessmentOutcomesList"
              icon="search"
              :loading="loading"
            >
              Run
            </loading-icon-text-button>
          </md-dialog-actions>
        </div>

        <div
          v-if="
            mlAssessmentOutcomes &&
            mlAssessmentOutcomes.length > 0
          "
        >
          <md-table v-model="mlAssessmentOutcomes">
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="ADP Status">Accept</md-table-cell>
              <md-table-cell md-label="Type">{{ item.type }}</md-table-cell>
              <md-table-cell md-label="Created Time">{{ item.created_date }}</md-table-cell>
              <md-table-cell md-label="Action">
                <loading-icon-text-button
                  class="md-primary md-sm"
                  icon="description"
                  @click="getAdpBreakdownDetail($event, item)"
                  :value="item.actions"
                  :loading="loading"
                >
                  {{ item.isSelected ? "Hide" : "Show" }}
                </loading-icon-text-button>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </div>
      </md-dialog-content>
    </group-card>

    <group-card title="ML Assessment Detail" icon="bubble_chart" padded>
      <md-dialog-content>
        <div v-if="applicationData">
          <div class="padded">
            <div v-for="(group, lenderId) in groupedData" :key="lenderId">
              <table class="data-table md-layout-item product-breakdown">
                <thead>
                  <tr>
                    <th>Lender</th>
                    <th>Product</th>
                    <th>Rule ID</th>
                    <th>Knockouts</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(ko, index) in group[0]" :key="index">
                    <td>
                      <div>
                        <div style="font-weight: bold;">{{ lenderId }}</div>
                        <img :src="'/images/lenders/' + lenderId + '.png'" width="10" />
                      </div>
                    </td>
                    <td>{{ ko.product_name }} <br> {{ ko.product_grade_name }}</td>
                    <td>{{ ko.rule_id }}</td>
                    <td>
                      <ul>
                        <li v-for="(note, noteIndex) in ko.ko_notes" :key="noteIndex">
                          {{ note }}
                        </li>
                      </ul>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div v-if="!isMLPayloadValid">
          <md-empty-state
            md-icon="close"
            md-label="No Data available for selected ML Assessment"
            md-description="Please select a more recent ML assessment to show detail."
          />
        </div>
        <div v-if="!applicationData && isMLPayloadValid">
          <md-empty-state
            md-icon="close"
            md-label="No ML Assessment selected"
            md-description="Please select an ML assessment to show detail."
          />
        </div>
      </md-dialog-content>
    </group-card>
  </div>
</template>
<script>
import GroupCard from "../components/Cards/GroupCard";
import LoadingIconTextButton from "@/components/LoadingIconTextButton";
import PropertyView from "../components/ApplicationSummary/PropertyView";
import GroupCardRow from "../components/Cards/GroupCardRow";
import filters from "@/components/utils/filters";
import utils from "@/components/utils/utils";
import AlertDialog from "../components/Dialogs/AlertDialog";
import ValidatedNumberInput from "../components/ValidatedInput/ValidatedNumberInput";

export default {
  components: {
    ValidatedNumberInput,
    LoadingIconTextButton,
    PropertyView,
    GroupCard,
    GroupCardRow,
  },
  data() {
    return {
      application_id: null,
      applicationData: null,
      loading: false,
      mlAssessmentOutcomes: [],
      isMLPayloadValid: true
    };
  },
  props: {
    targetId: {
      type: String,
      default: null,
    }
  },
  computed: {
    groupedData() {
      this.isMLPayloadValid = true;
      if (Array.isArray(this.applicationData.products_ko)) {
        this.isMLPayloadValid = false;
        this.showNotification("Try a more recent application", "Error!");
        return;
      }

      // Convert the observed object to an array of [key, value] pairs
      const productsKoArray = Object.entries(this.applicationData.products_ko);
      // Group data by lenderId
      const grouped = {};
      productsKoArray.forEach(([id, ko]) => {
        const lenderId = id.toString();
        if (!grouped[lenderId]) {
          grouped[lenderId] = [];
        }
        grouped[lenderId].push(ko);
      });
      return grouped;
    },
  },
  watch: {
    targetId: function(newVal, oldVal) {
      if (newVal) {
        this.application_id = newVal;
        this.getMlAssessmentOutcomesList();
      }
    }
  },
  methods: {
    // make all filters available as methods
    ...filters,
    ...utils,
    async getMlAssessmentOutcomesList() {
      // initial data
      this.applicationData = null;
      this.mlAssessmentOutcomes = [];
      if (!this.application_id) {
        this.showNotification("Application ID is required", "Error!");
        return;
      }
      //if application id is not number show error
      if (isNaN(this.application_id)) {
        this.showNotification("Application ID must be numbers.", "Error!");
        return;
      }
      try {
        this.loading = true;
        let response = await axios.get(
          `/api/v1/application/${this.application_id}/mlknockouts`
        );

        if (!response.data) {
          this.showNotification(response.data.message, "Error!");
          return;
        }

        this.mlAssessmentOutcomes = response.data.data;
        if (this.mlAssessmentOutcomes.length > 0) {
          this.mlAssessmentOutcomes.forEach(
            (element) => (element.isSelected = false)
          );
        }
        this.loading = false;
      } catch (e) {
        console.log(e);
        this.showNotification(e, "Error!");
      }
    },
    showNotification(message, title) {
      if (this.$modal.submit) {
        this.$modal.submit();
      }
      this.$modal.show(AlertDialog, {
        title: title,
        message: message,
      });
      this.loading = false;
    },
    getAdpBreakdownDetail(e, item) {
      if (item.isSelected) {
        this.applicationData = null;
        item.isSelected = false;
      } else {
        // set isSelected to current applicationData
        if (this.applicationData) {
          this.applicationData.isSelected = false;
        }
        item.isSelected = true;
        this.applicationData = item;
      }
    },
  },
  filters: {
    // make all filters available as filters
    ...filters,
  },
};
</script>
<style scoped>
.md-card img {
  width: 20% !important;
}
.product-breakdown {
  margin-bottom: 10px !important;
}
.product-breakdown tr,
.product-breakdown th {
  width: 20px !important;
}
.show-list-button {
  margin-top: 20px;
}
</style>
